import axios from "axios";
import { publicRequest, userRequest } from "./requestMethods";

// Web client wrapper around the platform `/api/reviews` endpoints. The two
// axios instances differ only in auth: `publicRequest` for read-only list
// fetches (so anonymous shoppers see reviews), `userRequest` for everything
// that mutates and therefore requires the bearer token.

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "lusuku";
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "lusuku-clou";

export const REVIEW_SUBJECT_TYPES = [
  "vendor_restaurant",
  "vendor_retailer",
  "vendor_healthcare",
  "vendor_brand",
  "product_restaurant",
  "product_retailer",
  "product_healthcare",
  "product_brand",
];

export const uploadReviewImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  form.append("upload_preset", UPLOAD_PRESET);
  form.append("folder", "reviews");
  form.append("tags", "review,user_generated");
  const { data } = await axios.post(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    form,
  );
  return { url: data.secure_url, publicId: data.public_id };
};

export const getReviews = ({
  subjectType,
  subjectId,
  sort = "most_helpful",
  page = 1,
  limit = 10,
}) =>
  publicRequest.get("/api/reviews", {
    params: { subjectType, subjectId, sort, page, limit },
  });

export const getVendorRatingSummary = ({ subjectType, subjectId }) =>
  publicRequest.get("/api/reviews/vendor-summary", {
    params: { subjectType, subjectId },
  });

export const submitReview = (payload) =>
  userRequest.post("/api/reviews", payload);

export const voteHelpful = (id) =>
  userRequest.post(`/api/reviews/${id}/helpful`);

export const replyToReview = (id, body) =>
  userRequest.post(`/api/reviews/${id}/reply`, { body });

export const deleteReview = (id) =>
  userRequest.delete(`/api/reviews/${id}`);

export const moderateReview = (id, isHidden) =>
  userRequest.patch(`/api/reviews/${id}/hide`, { isHidden });
